import { Button, Col, Row, Container, Card, CardText, CardTitle, CardImgOverlay, CardImg } from 'reactstrap';
import chip from './chip.jpeg'
import motherboard from './motherboard.jpeg'
import parts from './partsd.jpeg'
import setup from './setup.jpeg'
import fun from './fun.jpeg'
import windows from './windows.jpeg'
import '../info/info.css'
const Info = () => {
    return(
        <>
        <Container>
            <Row className='text-center mb-2'>
                <h1 className='text-primary' id='curriculum' style={{fontWeight:'bolder'}}>What you Learn?</h1>
            </Row>
            <Row>
                <Col lg={{size:'10', offset:'1'}} md={10} sm={12} >
                <Row>
                <Col md={4} sm={12} className='mb-5'>
                <Card className='infoCard' inverse style={{borderRadius:'20px'}}>
    <CardImg
      alt="Card image cap"
      src={chip}
      style={{
        height: 350,
        borderRadius:'20px'
      }}
      width="100%"
    />
    <CardImgOverlay style={{backgroundColor:'rgba(0, 0, 0, 0.4)', borderRadius:'20px'}}>
      <CardTitle className='mt-4 mb-3' tag="h3">
      Components
      </CardTitle>
      <CardText>
      Students learn about the main components required to build a PC. Each component serves a specific purpose and learining about what each component does helps the student building the best build under budget.
      </CardText>
    </CardImgOverlay>
  </Card>
                </Col>
                <Col md={4} sm={12} className='mb-5'>
                <Card className='infoCard' inverse style={{borderRadius:'20px'}}>
    <CardImg
      alt="Card image cap"
      src={motherboard}
      style={{
        height: 350,
        borderRadius:'20px'
      }}
      width="100%"
    />
    <CardImgOverlay style={{backgroundColor:'rgba(0, 0, 0, 0.6)', borderRadius:'20px'}}>
      <CardTitle className='mt-4 mb-3' tag="h3">
      Compatibility
      </CardTitle>
      <CardText>
      Each component has several variants so the students also learn about compatiblility between these components. From socket types to chipsets, we cover everything needed to make sure that all components are compatible
      </CardText>
    </CardImgOverlay>
  </Card>
                </Col>
                <Col md={4} sm={12} className='mb-5'>
                <Card className='infoCard' inverse style={{borderRadius:'20px'}}>
    <CardImg
      alt="Card image cap"
      src={parts}
      style={{
        height: 350,
        borderRadius:'20px'
      }}
      width="100%"
    />
    <CardImgOverlay style={{backgroundColor:'rgba(0, 0, 0, 0.8)', borderRadius:'20px'}}>
      <CardTitle className='mt-4 mb-3' tag="h3">
      Connections
      </CardTitle>
      <CardText>
      After getting the right and compatible components, its time to connect them together. Students learn the purpose of those complex and confusing wires coming out of the power supply which won't be as complex once this section is over.
      </CardText>
    </CardImgOverlay>
  </Card>
                </Col>
            </Row>
            <Row>
                <Col md={4} sm={12} className='mb-5'>
                <Card className='infoCard' inverse style={{borderRadius:'20px'}}>
    <CardImg
      alt="Card image cap"
      src={setup}
      style={{
        height: 350,
        borderRadius:'20px'
      }}
      width="100%"
    />
    <CardImgOverlay style={{backgroundColor:'rgba(0, 0, 0, 0.5)', borderRadius:'20px'}}>
      <CardTitle className='mt-4 mb-3' tag="h3">
      Setup
      </CardTitle>
      <CardText>
      Once we have our PC functioning, its time to set it up and configure to work according to our needs. This is where the operating system of our motherboards come in, also known as the BIOS.
      </CardText>
    </CardImgOverlay>
  </Card>
                </Col>
                <Col md={4} sm={12} className='mb-5'>
                <Card className='infoCard' inverse style={{borderRadius:'20px'}}>
    <CardImg
      alt="Card image cap"
      src={windows}
      style={{
        height: 350,
        borderRadius:'20px'
      }}
      width="100%"
    />
    <CardImgOverlay style={{backgroundColor:'rgba(0, 0, 0, 0.5)', borderRadius:'20px'}}>
      <CardTitle className='mt-4 mb-3' tag="h3">
      Operating system
      </CardTitle>
      <CardText>
      Now comes the easy part. The students finally gets to see their project in action. Students learn to wipe hard drives and get them ready to install Windows 11 from a bootable USB.
      </CardText>
    </CardImgOverlay>
  </Card>
                </Col>
                <Col md={4} sm={12} className='mb-5'>
                <Card className='infoCard' inverse style={{borderRadius:'20px'}}>
    <CardImg
      alt="Card image cap"
      src={fun}
      style={{
        height: 350,
        borderRadius:'20px'
      }}
      width="100%"
    />
    <CardImgOverlay style={{backgroundColor:'rgba(0, 0, 0, 0.5)', borderRadius:'20px'}}>
      <CardTitle className='mt-4 mb-3' tag="h1">
      Have Fun!
      </CardTitle>
      <CardText>
      This the last and most important section of our workshop. Students now have the compatible components built together. Hard drive has been wiped and Windows 11 is installed on the PC. It's time to now download games and watch this amazing custom built desktop in action.
      </CardText>
    </CardImgOverlay>
  </Card>
                </Col>
            </Row>
                </Col>
            </Row>
           
            
        </Container>
        </>
    )
}

export default Info;